// extracted by mini-css-extract-plugin
module.exports = {"sk-chase":"Spinner_sk-chase__3gZgr","sk-chase-dot":"Spinner_sk-chase-dot__2o0xK","sk-chase-dot-before":"Spinner_sk-chase-dot-before__2Thyc"};